"use client";

import React from "react";
import { Building2, Warehouse, Server, ArrowRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const ecosystems = [{
  title: "Uffici Aziendali",
  description: "Gestione integrata di workstation, sale riunioni e connettività per garantire ambienti di lavoro efficienti, flessibili e sempre operativi.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/corporate_office_workstations_professional.png",
  icon: Building2,
  link: "/SolutionsPage"
}, {
  title: "Logistica e Magazzini",
  description: "Supporto specializzato per dispositivi rugged, scanner industriali e infrastrutture wireless in ambienti operativi critici.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/logistics_center_warehouse_operations.png",
  icon: Warehouse,
  link: "/SolutionsPage"
}, {
  title: "Infrastrutture Distribuite",
  description: "Progettazione e monitoraggio di server, reti e sistemi cloud per assicurare resilienza e sicurezza dei dati aziendali.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570363/img/enterprise_datacenter_infrastructure_servers.png",
  icon: Server,
  link: "/SolutionsPage"
}];
export default function EcosistemiOperativi() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="ecosistemi-operativi" ref={ref} className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent opacity-20" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent opacity-20" />

      <div className="container mx-auto px-4 max-w-7xl">
        <div className={`mb-16 space-y-4 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white">Ecosistemi tecnologici</h2>
          <p className="text-muted-foreground max-w-2xl text-lg">Soluzioni tecnologiche progettate per supportare&nbsp;<span data-ast-id="f:/src/pages/Home/sections/EcosistemiOperativi.tsx|sig:i1sqlf" data-ast-start="2390" data-ast-end="2677" style={{
            color: 'rgb(148, 163, 184)',
            letterSpacing: '-0.32px'
          }}>ogni contesto lavorativo, dagli uffici direzionali&nbsp;</span><span data-ast-id="f:/src/pages/Home/sections/EcosistemiOperativi.tsx|sig:i06hli" data-ast-start="2677" data-ast-end="2970" style={{
            color: 'rgb(148, 163, 184)',
            letterSpacing: '-0.32px'
          }} contenteditable="false">ai centri logistici ad alta intensità.</span></p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {ecosystems.map((item, i) => <Link key={i} to={item.link} className="block group h-full" data-index={i}>
              <Card className={cn("h-full border-0 bg-transparent rounded-none overflow-hidden relative", "transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <AspectRatio ratio={3 / 4} className="relative w-full h-full bg-muted">
                  {}
                  <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 ease-out group-hover:scale-105" style={{
                backgroundImage: `url(${item.image})`
              }} />
                  
                  {}
                  <div className="absolute inset-0 bg-black/60 group-hover:bg-black/50 transition-colors duration-500" />

                  {}
                  <div className="absolute inset-0 flex flex-col justify-end p-8">
                    <div className="relative z-10 transform transition-transform duration-500 ease-out translate-y-12 group-hover:translate-y-0">
                      {}
                      <div className="flex items-center gap-3 mb-3">
                        <div className="p-2 bg-primary/10 backdrop-blur-sm border border-primary/20 text-primary rounded-none">
                          <item.icon className="w-5 h-5" />
                        </div>
                        <h3 className="text-xl font-bold text-white uppercase tracking-wide font-sans">
                          {item.title}
                        </h3>
                      </div>

                      {}
                      <div className="overflow-hidden transition-all duration-500 ease-out opacity-0 max-h-0 group-hover:opacity-100 group-hover:max-h-40 group-hover:mt-4">
                        <p className="text-gray-300 text-sm leading-relaxed border-l-2 border-primary pl-4">
                          {item.description}
                        </p>
                        <div className="mt-4 flex items-center text-primary text-sm font-medium uppercase tracking-wider">
                          Esplora Soluzione <ArrowRight className="ml-2 w-4 h-4" />
                        </div>
                      </div>
                    </div>
                  </div>

                  {}
                  <div className="absolute top-0 left-0 w-full h-full pointer-events-none border border-white/10 group-hover:border-primary/30 transition-colors duration-500" />
                  <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-primary/50 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                </AspectRatio>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}